<template>
  <span class="ai-avatar" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" fill="none" focusable="false">
      <circle cx="40" cy="40" r="39" fill="#E5F4F5" />
      <path d="M40 24v-7" stroke="#367986" stroke-width="3" stroke-linecap="round" />
      <circle cx="40" cy="13" r="4" fill="#62C4CD" stroke="#367986" stroke-width="2.5" />
      <rect x="10" y="36" width="9" height="16" rx="4.5" fill="#62C4CD" stroke="#367986" stroke-width="2.5" />
      <rect x="61" y="36" width="9" height="16" rx="4.5" fill="#62C4CD" stroke="#367986" stroke-width="2.5" />
      <rect x="17" y="24" width="46" height="40" rx="15" fill="#A7DFE3" stroke="#367986" stroke-width="2.5" />
      <rect x="23" y="31" width="34" height="26" rx="10" fill="#F7FDFD" />
      <path d="M32 40v4m16-4v4" stroke="#286271" stroke-width="4" stroke-linecap="round" />
      <path d="M35 49c3 3 7 3 10 0" stroke="#286271" stroke-width="2.5" stroke-linecap="round" />
      <circle cx="28" cy="48" r="2.5" fill="#F0B9AB" />
      <circle cx="52" cy="48" r="2.5" fill="#F0B9AB" />
    </svg>
  </span>
</template>

<style scoped>
.ai-avatar {
  display: inline-grid;
  place-items: center;
  flex: none;
  overflow: hidden;
  border-radius: 50%;
}

.ai-avatar svg {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
